import type { RouteMiddleware, RouteMiddlewareContext, RouteMiddlewareResult } from './types'

export default async function middlewarePipeline(
  context: RouteMiddlewareContext,
  middleware: RouteMiddleware[],
  index = 0
): Promise<RouteMiddlewareResult> {
  const currentMiddleware = middleware[index]
  if (!currentMiddleware) {
    return
  }

  const result = await currentMiddleware(context)
  return result === undefined ? middlewarePipeline(context, middleware, index + 1) : result
}
